export const PAGE_STATE = {
  DEFAULT: 'DEFAULT',
  EDIT: 'EDIT',
  READ: 'READ'
}
